export const end_url = "https://api.themoviedb.org/3/";
export const api_key = "cfe422613b250f702980a3bbf9e90716";
